'use client'

import React from 'react'

type Props = {
    initialVelocity: number
    acceleration: number
    timeS: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 40
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM

export default function VelocityTimeChart({ initialVelocity, acceleration, timeS }: Props) {
    const u = initialVelocity
    const a = acceleration
    const totalTime = Math.max(Math.abs(timeS), 0.0001)
    const vEnd = u + a * totalTime

    const minV = Math.min(u, vEnd, 0)
    const maxV = Math.max(u, vEnd, 0.0001)
    const range = maxV - minV || 1

    const xToSvg = (time: number) => PAD_LEFT + (time / totalTime) * PLOT_W
    const yToSvg = (v: number) => PAD_TOP + PLOT_H - ((v - minV) / range) * PLOT_H

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">Time (s)</text>
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">Velocity (m/s)</text>
            <line
                x1={xToSvg(0)} y1={yToSvg(u)}
                x2={xToSvg(totalTime)} y2={yToSvg(vEnd)}
                stroke="#2563eb" strokeWidth={2}
            />
            <circle cx={xToSvg(0)} cy={yToSvg(u)} r={4} fill="#16a34a" stroke="#fff" strokeWidth={1.5} />
            <circle cx={xToSvg(totalTime)} cy={yToSvg(vEnd)} r={4} fill="#dc2626" stroke="#fff" strokeWidth={1.5} />
        </svg>
    )
}
